import { render, staticRenderFns } from "./IframeWidget.vue?vue&type=template&id=ca76a844&scoped=true&"
import script from "./IframeWidget.vue?vue&type=script&lang=js&"
export * from "./IframeWidget.vue?vue&type=script&lang=js&"
import style0 from "./IframeWidget.vue?vue&type=style&index=0&id=ca76a844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca76a844",
  null
  
)

export default component.exports